<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
defineProps({
  records: { type: Array, required: true },
  busy: { type: Boolean, default: false },
});
const emit = defineEmits(['edit', 'remove']);
</script>

<template>
  <ul
    class="m-0 flex list-none flex-col divide-y divide-n-weak rounded-lg border border-n-weak p-0"
  >
    <li
      v-for="record in records"
      :key="record.id"
      class="flex flex-wrap items-center justify-between gap-4 p-4"
    >
      <div class="min-w-0 flex-1">
        <h2 class="break-words text-base font-medium text-n-slate-12">
          {{ record.name }}
        </h2>
        <p
          v-if="record.description"
          class="mb-2 whitespace-pre-wrap break-words text-sm text-n-slate-11"
        >
          {{ record.description }}
        </p>
        <p class="mb-0 text-sm text-n-slate-11">
          {{ $t('PERMISSION_SETS.MEMBERS', { count: record.members_count }) }}
        </p>
      </div>
      <div class="flex gap-2">
        <Button
          variant="ghost"
          :label="$t('PERMISSION_SETS.EDIT')"
          :disabled="busy"
          @click="emit('edit', record)"
        />
        <Button
          variant="ghost"
          color="ruby"
          :label="$t('PERMISSION_SETS.DELETE')"
          :disabled="busy || record.members_count > 0"
          @click="emit('remove', record)"
        />
      </div>
    </li>
  </ul>
</template>
